module.exports = __webpack_public_path__ + "img/equator_prize_logo-2015-en.a9d20197.png";